export default __webpack_public_path__ + "static/chip-e4ce030bdea3996fa7ad44ff63d88e52.svg";